<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-eighteen">
<h1>Chapter Eighteen</h1>
<p>For days, a maroon hardback-covered book lay intermittently on the table, deep inside a drawer, on the floor; now it was resting on Margaret’s lap, closed. Some days the cover had been opened, a black-crimson marble shaft fountain pen poised, her eyes staring unblinkingly at the cold, white, virginal page, her wrinkled fingers not ready to commit, and her heart not ready to share a long-ago buried secret. Her crooked old fingers traced random patterns over the cool leather. She knew only too well that facing up to her past was the only way to deprive them of their eternal dominion over her. The deep, inner secrets of her past were the secrets of another life, and yet it was her life, her secrets, and her past. The clock ticked ominously on. <em>Tick, tick, tick.</em></p>
<p>As the first streaks of misty dawn filtered through the opening of a heavily crushed-velvet drape, Margaret made a decision. She would either start or abandon. The choice, she concluded, was quite simple. Start or abandon. She opened the cover and picked up her pen. She stared into oblivion. She closed the cover, resting the gold-nibbed pen on top, her mind wandering. The cover opened. Snatching her pen, she put it back down again. Abandon or pursue; which was it going to be? Whichever option she ultimately chose, there was no going back. Pursue: abandon? The pen rose; the top clicked off. The top, clicked back on. Cover closed. Cover opened. Top off. Pen poised—the first poignant word written. The pen top clicked back on. The leather-bound cover closed.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch022.vue?4009146a